/*!
    * @product/scmp-sdk 1.0.204
    * d42aa2d3ce9b123c25308427836d5bf843621417
  */
function i(...d){var n,a;typeof window>"u"||!((n=window)!==null&&n!==void 0&&(a=n.dataLayer)!==null&&a!==void 0&&a.push)||window.dataLayer.push(arguments)}export{i as a};
//# sourceMappingURL=chunk-3XAZCID4.js.map
